import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Badge
} from "reactstrap";

const CrmLeadView = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const lead = location.state?.lead || {};

  const fullName =
    lead.name ||
    [lead.firstname, lead.lastname]
      .filter(Boolean)
      .join(" ") ||
    lead.company ||
    "-";

  return (
    <div className="page-content">
      <Container fluid>

        {/* Header */}
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div>
            <h4 className="mb-1">Lead Details</h4>
            <p className="text-muted mb-0">
              CRM / Leads / {fullName}
            </p>
          </div>

          <Button
            color="secondary"
            outline
            onClick={() => navigate(-1)}
          >
            <i className="ri-arrow-left-line me-1"></i>
            Back
          </Button>
        </div>

        {/* Lead Header */}
        <Card className="border-0 shadow-sm mb-4">
          <CardBody>
            <Row className="align-items-center">

              <Col md={8}>
                <div className="d-flex align-items-center">

                  <div
                    className="avatar-lg rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center me-3"
                    style={{ fontSize: "32px" }}
                  >
                    {fullName.charAt(0).toUpperCase()}
                  </div>

                  <div>
                    <h3 className="mb-1">
                      {fullName}
                    </h3>

                    <p className="text-muted mb-1">
                      {lead.company || "-"}
                    </p>

                    {lead.status && (
                      <Badge color="primary">
                        {lead.status}
                      </Badge>
                    )}
                  </div>

                </div>
              </Col>

              <Col md={4} className="text-md-end mt-3 mt-md-0">

                {lead.phone && (
                  <Button
                    color="success"
                    className="me-2"
                    onClick={() =>
                      window.open(`tel:${lead.phone}`)
                    }
                  >
                    <i className="ri-phone-line me-1"></i>
                    Call
                  </Button>
                )}

                {lead.email && (
                  <Button
                    color="primary"
                    outline
                    onClick={() =>
                      window.open(`mailto:${lead.email}`)
                    }
                  >
                    <i className="ri-mail-line me-1"></i>
                    Email
                  </Button>
                )}

              </Col>

            </Row>
          </CardBody>
        </Card>

        {/* Lead Information */}
        <Card className="border-0 shadow-sm mb-4">

          <CardBody>

            <h5 className="card-title mb-4">
              <i className="ri-user-line me-2 text-primary"></i>
              Lead Information
            </h5>

            <Row className="g-4">

              <Col md={6}>
                <label className="text-muted small">
                  First Name
                </label>
                <div className="fw-medium">
                  {lead.firstname || "-"}
                </div>
              </Col>

              <Col md={6}>
                <label className="text-muted small">
                  Last Name
                </label>
                <div className="fw-medium">
                  {lead.lastname || "-"}
                </div>
              </Col>

              <Col md={6}>
                <label className="text-muted small">
                  Company
                </label>
                <div className="fw-medium">
                  {lead.company || "-"}
                </div>
              </Col>

              <Col md={6}>
                <label className="text-muted small">
                  Email
                </label>
                <div className="fw-medium">
                  {lead.email || "-"}
                </div>
              </Col>

              <Col md={6}>
                <label className="text-muted small">
                  Phone
                </label>
                <div className="fw-medium">
                  {lead.phone || "-"}
                </div>
              </Col>

              <Col md={6}>
                <label className="text-muted small">
                  Course
                </label>
                <div className="fw-medium">
                  {lead.course || "-"}
                </div>
              </Col>

              <Col md={6}>
                <label className="text-muted small">
                  Lead Status
                </label>
                <div className="fw-medium">
                  {lead.status || "-"}
                </div>
              </Col>

              <Col md={6}>
                <label className="text-muted small">
                  Assigned To
                </label>
                <div className="fw-medium">
                  {lead.assignedTo || "-"}
                </div>
              </Col>

            </Row>

          </CardBody>
        </Card>

        {/* Address */}
        <Card className="border-0 shadow-sm mb-4">

          <CardBody>

            <h5 className="card-title mb-4">
              <i className="ri-map-pin-line me-2 text-primary"></i>
              Address Information
            </h5>

            <Row>

              <Col md={12}>
                <label className="text-muted small">
                  Address
                </label>

                <div className="fw-medium">
                  {lead.location || "-"}
                </div>
              </Col>

            </Row>

          </CardBody>
        </Card>

        {/* Custom Fields */}
        <Card className="border-0 shadow-sm">

          <CardBody>

            <h5 className="card-title mb-4">
              <i className="ri-settings-3-line me-2 text-primary"></i>
              Additional Information
            </h5>

            <Row className="g-4">

              <Col md={6}>
                <label className="text-muted small">
                  Course / Custom Field
                </label>

                <div className="fw-medium">
                  {lead.cf_907 || lead.course || "-"}
                </div>
              </Col>

              <Col md={6}>
                <label className="text-muted small">
                  Contact Person / Custom Field
                </label>

                <div className="fw-medium">
                  {lead.cf_911 || lead.assignedTo || "-"}
                </div>
              </Col>

              <Col md={6}>
                <label className="text-muted small">
                  Vtiger Lead ID
                </label>

                <div className="fw-medium text-break">
                  {lead._id || lead.id || "-"}
                </div>
              </Col>

            </Row>

          </CardBody>
        </Card>

      </Container>
    </div>
  );
};

export default CrmLeadView;
